/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import { TEC } from '@moderntribe/common/icons';
import './style.pcss';

export default () => (
	<div className="tribe-editor__icons__container tribe-editor__icons--tec">
		<TEC />
	</div>
);
